// extracted by mini-css-extract-plugin
export default {"userErrorScreen1":"styles_userErrorScreen1__AHoIU","userErrorScreen":"styles_userErrorScreen__TTylH"};